module.exports = __webpack_public_path__ + "img/no-data.db2f33ed.svg";